module.exports = __webpack_public_path__ + "media/images/h2-5db692ab4a1ba734af193627a3402809.svg";